import PropTypes from 'prop-types';
import ChassisArt from './ChassisArt';

const RULER_X = 15;

export const stageWidthCap = (geometry, maxHeightPx) => (
  `${Math.round(maxHeightPx * (geometry.width / geometry.height))}px`
);

export const DiagramGradients = ({ uid }) => (
  <>
    <linearGradient id={`${uid}-shell`} x1="0" x2="1" y1="0" y2="0">
      <stop offset="0" stopColor="#AEBAC4" />
      <stop offset="0.16" stopColor="#E5EBEF" />
      <stop offset="0.5" stopColor="#FFFFFF" />
      <stop offset="0.84" stopColor="#E5EBEF" />
      <stop offset="1" stopColor="#AEBAC4" />
    </linearGradient>
    <linearGradient id={`${uid}-shade`} x1="0" x2="0" y1="0" y2="1">
      <stop offset="0" stopColor="#FFFFFF" stopOpacity="0.62" />
      <stop offset="0.42" stopColor="#FFFFFF" stopOpacity="0" />
      <stop offset="1" stopColor="#0F172A" stopOpacity="0.14" />
    </linearGradient>
  </>
);

DiagramGradients.propTypes = { uid: PropTypes.string.isRequired };

const DiagramFrame = ({ geometry, uid }) => {
  const {
    body, axles, silhouette, centerX,
  } = geometry;

  return (
    <>
      <path className="tm-plate__centreline" d={`M${centerX} ${body.topEdge - 12}V${body.bottomEdge + 12}`} />

      <g className="tm-plate__compass">
        <path d={`M${centerX - 7} 16L${centerX} 8L${centerX + 7} 16`} />
        <text x={centerX} y="28">Front</text>
      </g>

      <g className="tm-plate__ruler">
        {axles.length > 1 && <path d={`M${RULER_X} ${axles[0].y}V${axles[axles.length - 1].y}`} />}
        {axles.map((axle) => (
          <g key={axle.key}>
            <path d={`M${RULER_X} ${axle.y}H${Math.min(...axle.tyres.map((tyre) => tyre.x - tyre.width / 2)) - 4}`} />
            <text x={RULER_X - 4} y={axle.y + 3.2}>{axle.label}</text>
          </g>
        ))}
      </g>

      <g transform={`translate(${centerX} 0)`}>
        <ChassisArt silhouette={silhouette} body={body} fill={`url(#${uid}-shell)`} shade={`url(#${uid}-shade)`} />
      </g>
    </>
  );
};

DiagramFrame.propTypes = {
  geometry: PropTypes.object.isRequired,
  uid: PropTypes.string.isRequired,
};

export default DiagramFrame;
